import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

export function ProgressRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()

  // element.variant holds the value as a string (e.g., "75")
  const rawValue = element.variant ? String(resolveSymbol(element.variant) ?? "0") : "0"
  const value = Math.max(0, Math.min(100, Number(rawValue) || 0))

  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        element.className,
      )}
      data-testid={`progress-${element.id}`}
    >
      <div
        className="h-full bg-primary transition-all"
        style={{ width: `${value}%` }}
      />
    </div>
  )
}
